import React, { useState } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import apiClient, { API_ENDPOINTS } from '../utils/api';
import { DEMO_CONFIG, isDemoMode } from '../utils/demo';

function Register() {
  if (isDemoMode()) {
    return (
      <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <Card style={{ width: '100%', maxWidth: '480px' }}>
          <Card.Body>
            <Card.Title className="text-center mb-3">新規登録</Card.Title>
            <Alert variant="warning" className="mb-3">
              デモ環境では新規登録は無効化されています。<br />
              共有のデモアカウント（<code>{DEMO_CONFIG.username}</code>）でログインしてご確認いただけます。
            </Alert>
            <p className="text-center mb-3">
              ご導入のご相談・お見積りはこちらまでお願いいたします。
            </p>
            <div className="d-grid gap-2">
              <Button
                variant="primary"
                href={DEMO_CONFIG.contactUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                お問い合わせフォームへ
              </Button>
              <Button as={Link} to="/login" variant="outline-secondary">
                ログイン画面に戻る
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>
    );
  }
  return <RegisterForm />;
}

function RegisterForm() {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('パスワードが一致しません');
      setLoading(false);
      return;
    }

    try {
      await apiClient.post(API_ENDPOINTS.REGISTER, {
        username: formData.username,
        email: formData.email,
        password: formData.password,
        first_name: formData.firstName,
        last_name: formData.lastName
      });

      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.detail || '登録に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Card style={{ width: '100%', maxWidth: '500px' }}>
        <Card.Body>
          <Card.Title className="text-center mb-4">新規登録</Card.Title>

          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleRegister}>
            <Form.Group className="mb-3">
              <Form.Label>ユーザー名</Form.Label>
              <Form.Control
                type="text"
                name="username"
                placeholder="ユーザー名を入力"
                value={formData.username}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>メールアドレス</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="メールアドレスを入力"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>名前</Form.Label>
              <div className="row">
                <div className="col">
                  <Form.Control
                    type="text"
                    name="firstName"
                    placeholder="名"
                    value={formData.firstName}
                    onChange={handleChange}
                  />
                </div>
                <div className="col">
                  <Form.Control
                    type="text"
                    name="lastName"
                    placeholder="姓"
                    value={formData.lastName}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>パスワード</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="パスワードを入力"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>パスワード確認</Form.Label>
              <Form.Control
                type="password"
                name="confirmPassword"
                placeholder="パスワードを再度入力"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100"
              disabled={loading}
            >
              {loading ? '登録中...' : '登録'}
            </Button>
          </Form>

          <p className="text-center mt-3">
            既にアカウントをお持ちの場合は <a href="/login">ログイン</a>
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Register;
